import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import { peselMask } from "../../../../../utilities/masks";
import {
  cityValidatorRequired,
  countryValidatorRequired,
  emailValidatorRequired,
  nameSurnameValidatorRequired,
  peselValidatorRequired,
  phoneValidatorRequired,
  postalCodeGenericValidator,
  postalCodePolandValidator,
  provinceValidator,
  radioValidator,
  streetHouseNumberValidatorRequired,
  streetValidatorRequired,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.VEHICLE_OWNER_PERSON_DATA]: yup.object({
    [ComponentId.NAME]: trimmedString.onlyIfFieldIsVisible(
      nameSurnameValidatorRequired
    ),
    [ComponentId.SURNAME]: trimmedString.onlyIfFieldIsVisible(
      nameSurnameValidatorRequired
    ),
    [ComponentId.PESEL]: trimmedString.onlyIfPeselFieldIsVisible(
      peselValidatorRequired
    ),
    [ComponentId.PHONE]: phoneValidatorRequired("ownerPersonphone"),
    [ComponentId.EMAIL]: trimmedString.onlyIfFieldIsVisible(
      emailValidatorRequired
    ),
    [ComponentId.STREET]: trimmedString.onlyIfFieldIsVisible(
      streetValidatorRequired
    ),
    [ComponentId.STREET_2]: trimmedString.onlyIfFieldIsVisible(
      streetHouseNumberValidatorRequired
    ),
    [ComponentId.ZIP_CODE_PL]: trimmedString.onlyIfFieldIsVisible(
      postalCodePolandValidator
    ),
    [ComponentId.ZIP_CODE_GENERIC]: trimmedString.onlyIfFieldIsVisible(
      postalCodeGenericValidator
    ),
    [ComponentId.CITY]: trimmedString.onlyIfFieldIsVisible(
      cityValidatorRequired
    ),
    [ComponentId.PROVINCE]:
      trimmedString.onlyIfFieldIsVisible(provinceValidator),
    [ComponentId.COUNTRY]: yup
      .object()
      .onlyIfFieldIsVisible(countryValidatorRequired),
    [ComponentId.COOWNER]: yup.string().onlyIfFieldIsVisible(radioValidator),
  }),
};
